export const normalizeSnilsDigits = (value = '') => {
  return value.replace(/\D/g, '').slice(0, 11);
};

export const hasManualSnilsDash = (rawValue = '') => {
  if (!rawValue) return false;
  let digitsSeen = 0;
  for (const char of rawValue) {
    if (/\d/.test(char)) {
      digitsSeen += 1;
    } else if (char === '-' && digitsSeen === 9) {
      return true;
    }
  }
  return false;
};

export const formatSnils = (digits, useDashAfterNine = false) => {
  if (!digits) return '';
  const normalizedDigits = String(digits).slice(0, 11);
  let result = '';

  for (let i = 0; i < normalizedDigits.length; i += 1) {
    if (i === 3 || i === 6) {
      result += '-';
    } else if (i === 9) {
      result += useDashAfterNine ? '-' : ' ';
    }
    result += normalizedDigits[i];
  }

  if (normalizedDigits.length === 9 && useDashAfterNine) {
    result += '-';
  }

  return result;
};
